import { SocialMedias, SocialMediaTypes } from "app/account/constants";

export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);

export const getSocialMediaObject = (socialMediaType: SocialMediaTypes) =>
  SocialMedias.filter(
    socialMedia => socialMedia.name === socialMediaType
  )?.[0] ?? null;
